import { createApi } from '@shared/redux/createApi';
import { createSlice } from '@reduxjs/toolkit';
import { serialize } from '@shared/lib/serialize';

const tags = {
  notifications: 'notifications',
};

export const pushNotificationsApi = createApi({
  reducerPath: 'pushNotificationsApi',
  tagTypes: Object.values(tags),
  endpoints: (builder) => ({
    getMailingList: builder.query({
      query: ({ page_number, page_size, sort_order }) => ({
        url: `/notifications/mailing-list?${serialize({
          page_number,
          page_size,
          sort_order
        })}`,
        method: 'get',
      }),
      transformResponse: (response) => ({
        list: response.mailing_list,
        count: response.page_amount
      }),
      providesTags: [tags.notifications]
    }),
    createMailing: builder.mutation({
      query: ({ title, description, is_all, user_ids }) => ({
        url: `/notifications/mailing`,
        method: 'post',
        body: { title, description, is_all, ...(user_ids && { user_ids }) }
      }),
      
      invalidatesTags: [tags.notifications]
    }),
  })
});

export const pushNotificationsParams = createSlice({
  name: 'pushNotificationsParams',
  initialState: {
    page: 1,
    limit: 100,
    sort_order: 'desc'
  },
  reducers: {
    setParams: (state, action) => {
      return { ...state, ...action.payload };
    }
  }
});

export const {
  useGetMailingListQuery,
  useCreateMailingMutation,
} = pushNotificationsApi;

export const { setParams } = pushNotificationsParams.actions;

export const pushNotificationsParamsSelector = (state) => state.pushNotificationsParams;
